import { render, staticRenderFns } from "./SearchTabs.vue?vue&type=template&id=1be93a53"
import script from "./SearchTabs.vue?vue&type=script&lang=js"
export * from "./SearchTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports